export enum OffersRevampSelfServeMigrationEvent {
    Click = 'OffersRevampSelfServeMigration.Click',
}
